<template>
  <div
    :class="submenuClass"
    class="submenu"
  >
    <div class="submenu__wrapp">
      <ArrowMenu
        v-if="!isShowPartnershipLogo"
        :items="secondArrowMenu.items"
        class="submenu__arrow-menu hide<big-tablet"
        theme="dark"
        @click-menu-item="sendEvent"
      />
      <!-- TODO поправить этот костыль-->
      <ArrowMenu
        v-if="!isShowPartnershipLogo"
        :items="mainArrowMenu.items"
        class="submenu__arrow-menu hide>tablet"
        theme="dark"
        @click-menu-item="sendEvent"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import ArrowMenu from '~/components/ArrowMenu.vue';
  import type { ILink } from '~/components/ArrowMenu/ArrowMenu';
  import { useMenusStore } from '~/store/menus';
  import { useSingleArticleStore } from '~/store/singleArticle';

  export default defineNuxtComponent({
    name: 'HeaderSubmenu',
    components: {
      ArrowMenu,
    },

    computed: {
      mainArrowMenu() {
        return useMenusStore().mainArrowMenu;
      },
      secondArrowMenu() {
        return useMenusStore().secondArrowMenu;
      },

      article() {
        return useSingleArticleStore().article;
      },

      isShowPartnershipLogo(): boolean {
        return !!this.article?.is_advertising;
      },

      submenuClass(): Record<string, boolean | undefined> {
        const className = 'submenu';
        return {
          [`${className}--partnership`]: this.isShowPartnershipLogo,
        };
      },
    },

    methods: {
      sendEvent(menuItem: ILink) {
        this.sendAnalytics(menuItem);
      },

      // Функция для аналитики клика на элемент меню хедера
      sendAnalytics(menuItem: ILink) {
        this.$sendYandexMetrika({
          level1: 'Клик_Хедер',
          level4: menuItem.link,
          level5: menuItem.title,
          level6: '2',
        });
      },
    },
  });
</script>

<style lang="scss" scoped>
  .submenu {
    background-color: black;
    filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.05));
    font-family: $text-font--1;

    &--partnership {
      background-color: #ffffff;
    }

    &__wrapp {
      max-width: 1300px;
      display: flex;
      justify-content: center;
      margin: 0 auto;
    }
  }
</style>
